<template>
    <ICountUp :delay="delay" :endVal="normalizedEndVal" :options="options" />
</template>

<script>
import ICountUp from "vue-countup-v2";

export default {
    name: "CountUpNumber",

    components: {
        ICountUp,
    },

    props: {
        endVal: {
            type: Number,
            required: true,
        },

        currency: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            delay: 0,
        };
    },

    computed: {
        normalizedEndVal() {
            const value = Number(this.endVal);
            return Number.isFinite(value) ? value : 0;
        },

        decimalPlaces() {
            return Number.isInteger(this.normalizedEndVal) ? 0 : 2;
        },

        options() {
            return {
                startVal: 0,
                duration: 0.5,
                useEasing: true,
                useGrouping: true,
                separator: ",",
                decimal: ".",
                decimalPlaces: this.decimalPlaces,
                prefix: this.currency ? `${this.currency} ` : "",
            };
        },
    },
};
</script>
